// src/shared/programList.js
const programList = [
    "Abrazo Health Network",
    "AdventHealth Florida",
    "Advocate Health Care/Advocate Christ Medical Center",
    "Alameda Health System-Highland Hospital",
    "Albany Medical Center",
    "Allegheny Health Network Medical Education Consortium",
    "Allegheny Health Network Medical Education Consortium (AGH)",
    "Arnot Ogden Medical Center",
    "Arrowhead Regional Medical Center",
    "Ascension Illinois/Resurrection",
    "Atlantic Health System/Morristown Medical Center",
    "Aultman Hospital/NEOMED",
    "Bayhealth Medical Center",
    "Baylor All Saints Medical Center Fort Worth",
    "Baylor College of Medicine",
    "Baylor Scott & White Medical Center - Baylor College of Medicine (Temple)",
    "Baylor University Medical Center",
    "Beth Israel Deaconess Medical Center/Harvard Medical School",
    "Boston University Medical Center",
    "Brooklyn Hospital Center",
    "Broward Health",
    "Capital Health Regional Medical Center",
    "Cape Fear Valley Health",
    "Carilion Clinic-Virginia Tech Carilion School of Medicine",
    "Carolinas Medical Center",
    "Case Western Reserve University/University Hospitals Cleveland Medical Center",
    "Central Iowa Health System (Iowa Methodist/Iowa Lutheran)",
    "Central Michigan University College of Medicine/CMU Medical Education Partners",
    "Charleston Area Medical Center/CAMC Institute for Academic Medicine",
    "Christiana Care Health Services",
    "CHRISTUS Health/Texas A&M University School of Medicine",
    "Cleveland Clinic Foundation/Akron General",
    "Conemaugh Memorial Medical Center",
    "Cook County Health and Hospitals System",
    "Cooper Medical School of Rowan University/Cooper University Hospital",
    "Corewell Health (Farmington Hills)",
    "Corewell Health (Trenton and Dearborn)",
    "Corewell Health Lakeland",
    "Corewell Health William Beaumont University Hospital",
    "Corewell Health – Grand Rapids/Michigan State University",
    "Creighton University School of Medicine",
    "Crozer-Chester Medical Center",
    "Darnall Army Medical Center",
    "Dartmouth-Hitchcock/Mary Hitchcock Memorial Hospital",
    "Denver Health Medical Center",
    "Desert Regional Medical Center",
    "Detroit Medical Center/Wayne State University (Detroit Receiving Hospital)",
    "Detroit Medical Center/Wayne State University (Sinai Grace)",
    "Dignity Health East Valley",
    "Duke University Hospital",
    "ECU Health Medical Center/East Carolina University",
    "Eisenhower Medical Center",
    "Emory University School of Medicine",
    "Florida Atlantic University Charles E. Schmidt College of Medicine",
    "Florida State University College of Medicine",
    "Franciscan Health Olympia Fields",
    "Garnet Health Medical Center",
    "George Washington University",
    "Geisinger Health System (Danville)",
    "Geisinger Health System (Wilkes Barre)",
    "Good Samaritan University Hospital",
    "Good Samaritan University Hospital/St Joseph Hospital Campus",
    "Hackensack University Medical Center",
    "HCA Florida Healthcare/Aventura Hospital",
    "HCA Florida Healthcare/Kendall Hospital",
    "HCA Florida Healthcare/St. Lucie Hospital",
    "HCA Florida Healthcare/USF Morsani College of Medicine GME - Tampa North/Oak Hill Hospital",
    "HCA Florida Healthcare/USF Morsani College of Medicine GME - Tampa South",
    "HCA Florida Healthcare/Westside/Northwest Hospital",
    "HCA Florida Orange Park Hospital",
    "HCA Healthcare LewisGale Medical Center",
    "HCA Healthcare Riverside",
    "HCA Healthcare Sunrise Health GME/MountainView",
    "HCA Healthcare/Mercer University School of Medicine/Grand Strand Medical Center",
    "HCA Healthcare/Mercer University School of Medicine/Trident Medical Center",
    "HCA Healthcare/TriStar Nashville/Skyline Medical Center",
    "HCA Houston Healthcare/University of Houston (Kingwood)",
    "HCA Medical City Healthcare UNT-TCU GME (Arlington)",
    "Health Education Services/Merit Health Wesley",
    "HealthPartners Institute/Regions Hospital",
    "Hennepin Healthcare",
    "Henry Ford Genesys Hospital",
    "Henry Ford Health/Henry Ford Hospital",
    "Henry Ford Health/Henry Ford Jackson Hospital",
    "Henry Ford Health/Henry Ford Macomb Hospital",
    "Henry Ford Health/Henry Ford Wyandotte Hospital",
    "Henry Ford Providence Hospital",
    "Henry Ford St. John Hospital",
    "Henry Ford Warren Hospital",
    "Icahn School of Medicine at Mount Sinai/Morningside/West",
    "Icahn School of Medicine at Mount Sinai/Mount Sinai Hospital",
    "Indiana University School of Medicine",
    "Inspira Health Network/Inspira Medical Center Mullica Hill",
    "Inspira Health Network/Inspira Medical Center Vineland",
    "Integris Health",
    "Jefferson Health Medical Education/Jefferson Einstein Montgomery Hospital",
    "Jefferson Health Medical Education/Jefferson Einstein Philadelphia Hospital",
    "Jefferson Health New Jersey",
    "Jefferson Health Northeast",
    "John Peter Smith Hospital (Tarrant County Hospital District)",
    "Johns Hopkins University",
    "Kaiser Permanente Northern California",
    "Kaiser Permanente Southern California",
    "Kansas City University GME Consortium (KCU-GME Consortium)/Freeman",
    "Kaweah Delta Health Care District (KDHCD)",
    "Kent Hospital",
    "Kern Medical Center",
    "Kettering Health Network",
    "Kirk Kerkorian School of Medicine at UNLV",
    "Lakeland Regional Health",
    "Lehigh Valley Health Network",
    "Lincoln Medical and Mental Health Center",
    "Loma Linda University Health Education Consortium",
    "Los Angeles County-Harbor-UCLA Medical Center",
    "Loyola University Medical Center",
    "Louisiana State University (Shreveport)",
    "Louisiana State University School of Medicine",
    "Louisiana State University School of Medicine (Baton Rouge)",
    "Madigan Army Medical Center",
    "MaineHealth",
    "Magnolia Regional Health Center",
    "Maimonides Medical Center",
    "Mass General Brigham/Massachusetts General Hospital/Brigham and Women’s Hospital/Harvard Medical School",
    "Mayo Clinic College of Medicine and Science",
    "McGaw Medical Center of Northwestern University",
    "McLaren Health Care/Macomb/MSU",
    "McLaren Health Care/Oakland/MSU",
    "Medical College of Georgia",
    "Medical College of Wisconsin Affiliated Hospitals",
    "Medical University of South Carolina",
    "MedStar Health Georgetown University",
    "Memorial Health System",
    "Memorial Healthcare System, Hollywood, Florida",
    "Mercy Health-St Rita's Medical Center",
    "Mercy St Vincent Medical Center/Mercy Health Partners",
    "Midwestern University GME Consortium / Kingman",
    "Montefiore Medical Center/Albert Einstein College of Medicine (Jacobi/Montefiore)",
    "Mount Sinai Medical Center of Florida, Inc",
    "Nassau University Medical Center",
    "Nazareth Hospital",
    "Naval Medical Center (Portsmouth)",
    "Naval Medical Center (San Diego)",
    "New York Medical College (Metropolitan/Harlem)",
    "New York Presbyterian Hospital",
    "New York-Presbyterian Brooklyn Methodist Hospital",
    "New York-Presbyterian/Queens",
    "Northwell — NYU Grossman Long Island School of Medicine",
    "Northeast Georgia Medical Center",
    "Nuvance Health Consortium (Vassar Brothers Medical Center)",
    "NYC Health & Hospitals/South Brooklyn Health",
    "NYU Grossman Long Island School of Medicine",
    "NYU Grossman School of Medicine",
    "Ochsner Clinic Foundation",
    "Ohio State University Hospital",
    "OhioHealth/Doctors Hospital",
    "Oklahoma State University Center for Health Sciences (Lawton)",
    "Oklahoma State University Center for Health Sciences (Norman)",
    "Oklahoma State University Center for Health Sciences (Tulsa)",
    "Old Dominion University",
    "One Brooklyn Health System/Brookdale University Hospital and Medical Center",
    "Oregon Health & Science University (OHSU Health)",
    "Orlando Health",
    "Penn State Milton S Hershey Medical Center",
    "Prisma Health/University of South Carolina SOM Columbia (Columbia)",
    "Prisma Health/University of South Carolina SOM Greenville (Greenville)",
    "Rhode Island Hospital/Brown University Health",
    "Riverside Regional Medical Center",
    "Riverside University Health System",
    "Robert Packer Hospital",
    "Rush University Medical Center",
    "Rutgers Health/Community Medical Center",
    "Rutgers Health/New Jersey Medical School",
    "Rutgers Health/Newark Beth Israel Medical Center",
    "Rutgers Health/Robert Wood Johnson Medical School",
    "San Antonio Uniformed Services Health Education Consortium",
    "Sidney Kimmel Medical College at Thomas Jefferson University/TJUH",
    "Southwest Healthcare Medical Education Consortium",
    "Southern Illinois University School of Medicine",
    "SSM Health/Saint Louis University School of Medicine",
    "St Barnabas Hospital",
    "St Elizabeth Boardman Hospital",
    "St Joseph's Medical Center",
    "St Joseph's University Medical Center",
    "St Luke's University Hospital",
    "St Luke’s Hospital – Anderson Campus",
    "St. Agnes Medical Center (Fresno)",
    "Stanford Health Care-Sponsored Stanford University",
    "Stony Brook Medicine/University Hospital",
    "SUNY Downstate Health Sciences University",
    "SUNY Upstate Medical University",
    "Sutter Health/Sutter Roseville Medical Center",
    "Swedish Hospital",
    "Temple University Hospital",
    "Texas Tech University HSC El Paso",
    "Texas Tech University Health Sciences Center at Lubbock",
    "The MetroHealth System/Case Western Reserve University",
    "Tower Health/Reading Hospital",
    "Trinity Health Livonia Hospital/Wayne State University",
    "Trinity Health Muskegon",
    "Trinity Health System",
    "UCLA David Geffen School of Medicine/UCLA Medical Center/Olive View",
    "UMass Chan - Baystate",
    "UMass Chan Medical School",
    "Unity Health-White County Medical Center",
    "University at Buffalo",
    "University Hospitals Community Consortium",
    "University of Alabama Medical Center",
    "University of Arizona College of Medicine-Tucson",
    "University of Arizona College of Medicine-Tucson (South Campus)",
    "University of Arkansas for Medical Sciences (UAMS) College of Medicine",
    "University of California (Irvine)",
    "University of California (San Diego) Medical Center",
    "University of California (San Francisco)/Fresno",
    "University of California (San Francisco)/San Francisco General Hospital",
    "University of California Davis Health",
    "University of Central Florida/HCA Florida Healthcare (Gainesville)",
    "University of Central Florida/HCA Florida Healthcare (Greater Orlando/Osceola)",
    "University of Central Florida/HCA Florida Healthcare (Ocala)",
    "University of Chicago",
    "University of Cincinnati Medical Center/College of Medicine",
    "University of Connecticut",
    "University of Florida",
    "University of Florida College of Medicine Jacksonville",
    "University of Illinois College of Medicine at Chicago",
    "University of Illinois College of Medicine at Peoria",
    "University of Iowa Hospitals and Clinics",
    "University of Kansas School of Medicine",
    "University of Kentucky College of Medicine",
    "University of Louisville School of Medicine",
    "University of Maryland",
    "University of Miami/Jackson Health System",
    "University of Michigan",
    "University of Michigan Health - Sparrow/Michigan State University",
    "University of Michigan Health-West",
    "University of Mississippi Medical Center",
    "University of Missouri-Columbia",
    "University of Missouri-Kansas City School of Medicine",
    "University of Nebraska Medical Center",
    "University of New Mexico School of Medicine",
    "University of North Carolina Hospitals",
    "University of Oklahoma School of Community Medicine (Tulsa)",
    "University of Pennsylvania Health System",
    "University of Puerto Rico",
    "University of Rochester Medical Center",
    "University of South Florida Morsani",
    "University of Southern California/Los Angeles General Medical Center (USC/LA General)",
    "University of Tennessee College of Medicine at Chattanooga",
    "University of Tennessee College of Medicine at Memphis",
    "University of Tennessee College of Medicine at Murfreesboro",
    "University of Texas Health Science Center San Antonio Joe and Teresa Lozano Long School of Medicine",
    "University of Texas Health Science Center at Houston",
    "University of Texas Medical Branch Hospitals",
    "University of Texas Southwestern Medical Center",
    "University of Texas at Austin Dell Medical School",
    "University of Utah Health",
    "University of Vermont Medical Center",
    "University of Virginia Medical Center",
    "University of Washington",
    "University of Wisconsin Hospitals and Clinics",
    "UPMC Medical Education (Erie)",
    "UPMC Medical Education (Harrisburg)",
    "UPMC Medical Education (Pittsburgh)",
    "USA Health",
    "Vanderbilt University Medical Center",
    "Virginia Commonwealth University Health System",
    "Wake Forest University Baptist Medical Center",
    "Washington University/B-JH/SLCH Consortium",
    "Wellspan Health/York Hospital",
    "Wellstar Health System/Wellstar Kennestone Regional Medical Center",
    "West Virginia University",
    "Western Michigan University Homer Stryker MD School of Medicine",
    "Wright State University",
    "Wyckoff Heights Medical Center",
    "Yale-New Haven Medical Center",
    "Zucker School of Medicine at Hofstra/Northwell",
    "Zucker School of Medicine at Hofstra/Northwell at South Shore University Hospital",
    "Zucker School of Medicine at Hofstra/Northwell at Staten Island University Hospital"
];

export default programList;
